import get from 'lodash.get';
import { getOffices } from '@/services/office';

// eslint-disable-next-line no-unused-vars
const initializeOffices = async (store) => {
  const getOfficesResponse = await getOffices();
  return get(getOfficesResponse, 'data.getOffices');
};

export default {
  initializeOffices,
};



// WEBPACK FOOTER //
// ./store/modules/offices/actions.js